<template>
  <div
    class="mb-72 mt-24 md:mb-24"
    data-qa="contact-screen"
    data-test="contact-screen"
  >
    <ContactShell :with-attachments="false" @submit="submitRequest" />
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import type { MachineSend } from '@/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'
import type { ReturnFunnelMachineEvents } from '~/scopes/customer-care/resolution/machine/schemas/ReturnFunnel/ReturnFunnel.types'

import type { ContactFormValues } from '../../../../common/ContactShell/ContactShell.types'
import ContactShell from '../../../../common/ContactShell/ContactShell.vue'

import translations from './ContactScreen.translations'
import type {
  ContactScreenEmits,
  ContactScreenProps,
} from './ContactScreen.types'

const props = defineProps<ContactScreenProps>()

const emit = defineEmits<ContactScreenEmits>()

const i18n = useI18n()
const { openErrorToast } = useTheToast()

const send = props.machineSend as MachineSend<ReturnFunnelMachineEvents>

const hasSubmitError = computed(() =>
  props.machineState.matches('RETURN_FUNNEL.SUBMISSION_ERROR'),
)

function submitRequest(payload: ContactFormValues) {
  send({
    type: 'CONTINUE',
    payload: {
      description: payload.details,
      needMoreHelp: false,
    },
  })
  emit('submit')
}

watch(
  hasSubmitError,
  (isError) => {
    if (isError) {
      openErrorToast({
        title: i18n(translations.errorToastTitle),
        content: i18n(translations.errorToastDescription),
        closeCallback: () => send('BACK'),
        name: 'resolution-flow-return-contact-screen-submition-error-toast',
      })
    }
  },
  { immediate: true },
)
</script>
